import { sessionAtom } from '../../lib/recoil/persist';
import { PartnerData } from '../../types/responseSchema/partnerData';

const b2bRegisterPartner = sessionAtom<PartnerData | null>({
  key: 'b2bRegisterPartner',
  default: null,
});

export default b2bRegisterPartner;
